import { CountryCode } from './../../explore-map.model';
import { DatasetsService } from './../../../datasets/datasets.service';
import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { AnonMapService } from '../../../../shared/models/map-services.model';

@Component({
  selector: 'app-datasets-list',
  templateUrl: './datasets-list.component.html',
  styleUrls: ['./datasets-list.component.scss'],
})
export class DatasetsListComponent implements OnInit, OnDestroy {
  @Input() activeMapServiceSlug: string;
  @Input() countryAtCoordinates?: CountryCode;
  $searchTermSubject: Subject<string> = new Subject<string>();
  searchTerm: string = '';
  onDestroy$ = new Subject();
  datasets: AnonMapService[];
  filteredDatasets: AnonMapService[];

  constructor(private datasetsService: DatasetsService) {}

  /**
   * Listen for changes in the feature
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (this.datasets && changes.countryAtCoordinates) {
      this.filterOnCountryCode();
    }
  }

  ngOnInit() {
    this.getDatasets();
    this.$searchTermSubject
      .pipe(takeUntil(this.onDestroy$))
      .pipe(debounceTime(600))
      .subscribe((searchText) => {
        this.filterDatasetsList();
      });
  }

  /**
   * Debounce Helper Mechanism
   * @param query
   */
  onFieldChange(query: string) {
    this.filterDatasetsList();
    this.$searchTermSubject.next(query);
  }

  filterDatasetsList(): void {
    this.filteredDatasets = this.datasets.filter((dataset) => {
      return (
        this.themeMatch(dataset) ||
        this.countryMatch(dataset) ||
        this.descriptionMatch(dataset) ||
        this.nameMatch(dataset)
      );
    });
  }

  filterOnCountryCode(): void {
    this.filteredDatasets = this.datasets.filter((dataset) => {
      return this.countryCodeMatch(dataset);
    });
  }

  nameMatch(dataset): boolean {
    if (dataset.name) {
      return dataset.name.toLowerCase().match(this.searchTerm.toLowerCase());
    } else {
      return false;
    }
  }

  themeMatch(dataset): boolean {
    let match = false;
    if (dataset.mapServiceMetadata && dataset.mapServiceMetadata.themes) {
      dataset.mapServiceMetadata.themes.split(',').map((theme) => {
        if (theme.toLowerCase().match(this.searchTerm.toLowerCase())) {
          match = true;
        }
      });
    }

    return match;
  }
  countryCodeMatch(dataset): boolean {
    let match = false;
    if (dataset.mapServiceMetadata && dataset.mapServiceMetadata.coverage) {
      dataset.mapServiceMetadata.coverage.map((country) => {
        if (country.ISO == this.countryAtCoordinates.locationCountryCode) {
          this.searchTerm = country.name;
          match = true;
        }
      });
    }
    return match;
  }
  countryMatch(dataset): boolean {
    let match = false;
    if (dataset.mapServiceMetadata && dataset.mapServiceMetadata.coverage) {
      dataset.mapServiceMetadata.coverage.map((country) => {
        if (country.name.toLowerCase().match(this.searchTerm.toLowerCase())) {
          match = true;
        }
      });
    }
    return match;
  }
  descriptionMatch(dataset): boolean {
    if (dataset.mapServiceDescription) {
      return dataset.mapServiceDescription.toLowerCase().includes(this.searchTerm.toLowerCase());
    } else {
      return false;
    }
  }

  resetSearch(): void {
    this.searchTerm = '';
    this.filteredDatasets = this.datasets;
  }

  getDatasets(): void {
    this.datasetsService
      .getDatasets()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((datasets) => {
        this.datasets = datasets;
        this.filteredDatasets = datasets;
      });
  }

  get loading(): boolean {
    return this.datasetsService.datasetsLoading;
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
